module.exports = __webpack_public_path__ + "static/media/logowhiteboxmedium.1659b5ee.png";